import React, { useRef } from 'react';
import { Box, DialogV2, Flex } from '@withjoy/joykit';
import {
  StyledCtaContainer,
  StyledDialogV2,
  StyledDialogV2BodyContainer,
  StyledDialogV2CloseButton,
  StyledEyebrow,
  StyledTitle,
  StyledVideoContainer,
  styles,
} from './CurationVideoPlayerDialog.styles';
import { CurationCta } from '../../routes/CurationsIndex/components/CurationHeroHeader/components/CurationCta/CurationCta';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
// import { useVimeoPlayerAnalytics } from '../../utils/vimeoPlayer';
import { useCurationVideoPlayerAnalytics } from '../../hooks/useCurationVideoPlayerAnalytics';

interface CurationVideoPlayerProps
  extends Readonly<{
    curationId: string;
    videoUrl: string;
    eyebrow: Maybe<string>;
    title: Maybe<string>;
    onExploreCurationClick: React.MouseEventHandler | null;
    isOpen: boolean;
    onClose: () => void;
  }> {}

const DialogBody = (props: CurationVideoPlayerProps) => {
  const { curationId, videoUrl, eyebrow, title, onExploreCurationClick } = props;
  const autoplayVideoUrl = `${videoUrl}&autoplay=1`;
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isMobile = useIsMobileScreen();

  const { vimeoIframeRef, isPlaying } = useCurationVideoPlayerAnalytics({ element: iframeRef.current, curationId, curationTitle: title });

  return (
    <DialogV2.Body __css={styles.dialogV2Body}>
      <StyledDialogV2BodyContainer __css={styles.dialogV2BodyContainer}>
        <StyledCtaContainer __css={styles.dialogV2MobileCtaContainer}>
          {isMobile && (
            <Flex flexDirection="column">
              {eyebrow && <StyledEyebrow typographyVariant="body1">{eyebrow}</StyledEyebrow>}
              {title && <StyledTitle typographyVariant="hed4">{title}</StyledTitle>}
            </Flex>
          )}
        </StyledCtaContainer>
        <StyledVideoContainer __css={styles.dialogV2VideoContainer}>
          <iframe
            ref={vimeoIframeRef}
            src={autoplayVideoUrl}
            title={videoUrl}
            frameBorder="0"
            width="100%"
            height="100%"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        </StyledVideoContainer>
        <StyledCtaContainer __css={styles.dialogV2CtaContainer}>
          {!isMobile && (
            <Flex flexDirection="column">
              {eyebrow && <StyledEyebrow typographyVariant="label1">{eyebrow}</StyledEyebrow>}
              {title && <StyledTitle typographyVariant="hed1">{title}</StyledTitle>}
            </Flex>
          )}
          {onExploreCurationClick && (
            <Box>
              <CurationCta
                method="videoPlayer"
                data-isvideoplaying={isPlaying}
                onClick={onExploreCurationClick}
              />
            </Box>
          )}
        </StyledCtaContainer>
      </StyledDialogV2BodyContainer>
    </DialogV2.Body>
  );
};

const CurationVideoPlayerDialog: React.FC<CurationVideoPlayerProps> = props => {
  const { isOpen, onClose } = props;

  return (
    <StyledDialogV2
      id="CurationHeroVideoPlayer"
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      overrides={{
        CloseButton: {
          props: {
            top: ['20px', '6px'],
            right: ['20px', '6px'],
          },
        },
      }}
    >
      <StyledDialogV2CloseButton
        zIndex="modal"
        __css={styles.dialogV2CloseButton}
      />
      <DialogBody {...props} />
    </StyledDialogV2>
  );
};

export { CurationVideoPlayerDialog };
